import { Tag, Tooltip } from "antd";
import { describeRepeat, STATUS_META } from "./appraisalHelpers";

export const StatusTag = ({ row }) => (
    <Tooltip title={STATUS_META[row.status]?.hint}>
        <span>
            <Tag color={STATUS_META[row.status]?.color}>{STATUS_META[row.status]?.label || row.status}</Tag>
            {row.overdue && <Tag color="red">Overdue</Tag>}
        </span>
    </Tooltip>
);

// small marker on an appraisal that belongs to a repeating schedule
export const RepeatTag = ({ months }) => (months ? <Tag style={{ marginLeft: 6 }}>↻ {describeRepeat(months)}</Tag> : null);

export const reviewerText = (row) =>
    row.reviewerName || (row.candidateCount ? <span className="cmp-muted">Shared ({row.candidateCount})</span> : <span className="cmp-overdue">No reviewer</span>);
